export const environment = {
    production: false,
    uat: false,
    apiServer: 'https://devepayment.gsc.my/',
    invoiceServer: 'https://devepayment.gsc.my/',
    ascentisApiServerDomain: 'https://gsc-api-wrapper-uat.ascentis.com.sg/',
    ascentisApiServer: 'https://gsc-api-wrapper-uat.ascentis.com.sg/',
    gaMid: 'G-R78KFRTM40',
    pixelId: '375076430344088', // staging PT id - '704090293383995',
    gtmId: 'GTM-NPHWTTC7',
    adsId: 'AW-16543093298',
    originUrl: 'https://stagingepaymentwebapp.gsc.my',
    proxyUrl: 'https://stagingepaymentwebapp.gsc.my/api',
    proxyToken: 'https://stagingepaymentwebapp.gsc.my/api/token',
    // originUrl: 'https://gsc-eticket-staging.azurewebsites.net/',
    // proxyUrl: 'https://gsc-eticket-staging.azurewebsites.net/api',
    // proxyToken: 'https://gsc-eticket-staging.azurewebsites.net/api/token',
    initSalesTransactionVersion: '4.0.0',
    paymentGatewayUrl: 'https://secure4.gsc.my/epayappdev/pub/emreq/emallpay_req.do',
    fnbPaymentGatewayUrl: 'https://secure4.gsc.my/epayappdev/pub/emreq/doPaymentReqCSO.do',
    isGp: false,
    enableServerLogging: true,
};
